<script setup>
    import FormularioBuscarTarjeta from '../../components/formularioBuscarTarjeta.vue';

</script>
<template>
    <FormularioBuscarTarjeta urlSiguiente="/cliente/verificar"/>
</template>
